export default __webpack_public_path__ + "static/media/i121sp.e6d00070.webp";